import {
    styled,
    Button as UiButton,
    Typography,
} from "@mui/material"

import { SIDEBAR_SPACING, SIDEBAR_SPACING_MOBILE } from "../../constants/layout"
import { styledForMobile } from "../../utils/styledForMobile"

export const Container = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
}))

export const SidebarHeader = styledForMobile("div", ["hasBottomComponent"])(({ hasBottomComponent, theme, isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: isMobile ? theme.spacing(0, SIDEBAR_SPACING_MOBILE, hasBottomComponent ? 1 : SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE)
        : theme.spacing(0, SIDEBAR_SPACING, hasBottomComponent ? 1 : 5, SIDEBAR_SPACING),
}))

export const TitleContainer = styled("div")({
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    width: "100%",
})

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    lineHeight: "34px",
    flexGrow: 1,
}))

export const Button = styled(UiButton)(({ theme }) => ({
    minWidth: "unset",
    width: "fit-content",
    textTransform: "initial",
    padding: 0,
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(4),
}))

export const TitleSideComponent = styled("div")(({ theme }) => ({
    marginLeft: theme.spacing(9),
    marginRight: 0,
}))